module.exports = __webpack_public_path__ + "static/media/vibino-feature- photo straighten-pic1.8f67b26b.jpg";